<template>
  <div id="app">
    <router-view></router-view>
  </div>
</template>

<script>
// import { globalStore,setStorage } from '@/libs/system'
import { globalStore,setStorage } from '@/libs/system'

import GLOBAL from './config/config'
export default {
  name: 'app',
  data(){
    return {
      globalStore
    }
  },
  mounted () {
    this.$get('index/web').then(res=>{
      this.updateValue(res.data.length === 0 ? {
        left_logo:require('./assets/img/xinli_logo.png'),
        right_logo:require('./assets/img/logo.png'),
        title:'喜安心理线上施测系统',
        base:true,
        ico: GLOBAL.WEB_SITE+'/static/web/ico/default.ico'
      } : res.data)
    })
  },
  methods:{
    updateValue(data){
      setStorage('web',data)
    }
  },
  watch:{
    "globalStore.web":{
      handler(newStore){
        document.title = newStore.title
        let link = document.querySelector("link[rel='icon']")
        if (!link) {
          link = document.createElement("link");
          link.rel = 'icon';
          document.head.appendChild(link);
        }
        link.href = newStore.ico;
      },
      deep: true,
      immediate: true
    }
  }
}
</script>

<style>
body{
  background-color: #e9eaed !important;
}
</style>
